import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { jumpToUser, } from 'src/helper/webviewFun'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import vs from '../../../../helper/vconsole'
import http from 'src/helper/http'
import Message from 'src/component/Message'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
@inject('store')
@observer

export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    topReward: [],
    topRankList:[],
    myRank:{},
    rankList:[],
    voteReward:[],
    lang:lang.en,
    language:'en',
    giftList:[],
    minute:0,
    day:0,
    hour:0,
    second:0,
  }

  async componentDidMount() {
    const uid = await setUidToken(this.props.location.query)
    let { language } = this.props.location.query
    language =await getlang(language)
    await this.setState({
      lang: setlang(language, lang),
      language: language,
      uid
    })
    this.getRankList()
    this.getRankTopList()
    this.getRankGiftList()
    this.getRankRewardList()
    this.getCountDownTime()
  }
  getCountDownTime = async () => {
    let nowTime = Math.floor(new Date().getTime() / 1000)
    let res = await http.post('web/valentine/timeinfo')
    if (nowTime > res.res.beginTimestamp) {
      this.countDown(res.res.leftTimestamp)
    }
  }
  getRankList = async()=>{
    let res = await http.post('/web/valentine/rank',{scroll:'0,20'})
    if (res.code == 0 ) {
      console.log(res.res.list)
       this.setState({
        rankList: res.res.list
       })
    }
  }

  getRankGiftList = async()=>{
    let res = await http.post('/web/valentine/rankgiftlist')
    if (res.code == 0 ) {
      console.log(res,58)
      this.setState({
        giftList:res.res
      })
    }
  }

  getRankTopList =async ()=>{
    let res = await http.post('/web/valentine/ranktop')
    if (res.code == 0) {
       this.setState({
        topRankList:res.res.list,
        myRank:res.res.mine
       })
    }
  }
  
  getRankRewardList = async ()=>{
    let res = await http.post('/web/valentine/rankrewardlist')
    if (res.code == 0 ) {
      this.setState({
        voteReward:res.res.voteReward || [],
        topReward:[res.res.rankReward1,res.res.rankReward2,res.res.rankReward3,res.res.rankReward4] 
      })
    }
  }
  // 
  showPrizeModle = (open, close) => {
    let { topReward, voteReward, language, lang } = this.state
    return (
      <div
        className="topLovers-prize-modle"
      >
        <img className='bg-in-prize-modle' src='/img/activity/valentineDay/prize_border_bg.png'></img>
        <img src={language == 'ar'?'/img/activity/valentineDay/prize-modle_title_bg_ar.png':language == 'tr'?'/img/activity/valentineDay/prize-modle_title_bg_tr.png':'/img/activity/valentineDay/prize-modle_title_bg.png'} className='top-title'></img>
        <div className='topLovers-prize-modle-body-root' >
        <div className='prize-modle-body'>
          {topReward.length > 0 && topReward.map((item, index) => (<div className='prize-body-item' key={index}>
          <div className='title-index'>{index == 0?lang.topOneText:index == 1?lang.topTwoText:index == 2?lang.topThreeText:lang.topFourText}</div>
            <div className='body-show-item'>
              {item.length > 0 && item.map((i, d) => (<div className='item-in-prize' key={d}>
                <div className='img-root'>
                  <img className='img-root-img' style={{padding:`${i.rewardType == 'title'?'0.42rem 0':'0 0'}`,boxSizing:'border-box'}} src={language == 'tr' ? i.picTr : language == 'ar' ? i.picAr : i.pic}></img>
                  <div className='gift-time-root' >{language == 'ar' ? i.rewardNum+ 'يوم': language == 'tr' ? i.rewardNum + 'Gün' :i.rewardNum + 'day'  }</div>
                </div>
                <div className='name-text'>{language == 'tr' ? i.rewardNameTr : language == 'ar' ? i.rewardNameAr : i.rewardName}</div>
              </div>))}
            </div>
          </div>))}
        </div>
        </div>
      </div>
    )
  }
  //
  showRulesModle = (open, close) => {
    let { language } = this.state
    return (
      <div
        className="topLovers-rules-modle"
      >
        <img className='bg-in-prize-modle' src='/img/activity/valentineDay/rules_border_bg.png'></img>
        <img src={language == 'ar'?'/img/activity/valentineDay/rules-modle_title_bg_ar.png':language == 'tr'?'/img/activity/valentineDay/rules-modle_title_bg_tr.png':'/img/activity/valentineDay/rules-modle_title_bg.png'} className='top-title'></img>
        <div style={{ height: '0.28rem' }}></div>
        <div className='prize-modle-body'>
          <div className="ye" dangerouslySetInnerHTML={{ __html: this.state.lang ? this.state.lang.rewardRule : '' }}></div>
        </div>
      </div>
    )
  }
  //倒计时
  countDown = (times) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(
      () =>{
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + ' '+ lang.days 
          console.log(daystr)
        }
        this.setState({
          day,
          hour,
          second
        })
        times--
       
      },
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }
  render() {
    let { lang, language, myRank, topRankList, rankList, giftList, day, hour, second, minute  } = this.state
    return (
      <div className={`topLovers ${language == 'ar' ? 'arlang' : ''}`} key={6}>
        <div className='banner-root'>
          <div style={{ height: '2.1rem' }}></div>
          <div className={language == 'ar'?'title-root-ins-ar':language == 'tr'?'title-root-ins-tr':'title-root-ins'}>
            {/* <div className='bootm'>Prove to me your love</div> */}
          </div>
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="rules" >
                {lang ? lang.rule : ''}
              </div>
            }}
            slotContentComp={this.showRulesModle}
          />

          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="prize" >
                {lang.prize}
              </div>
            }}
            slotContentComp={this.showPrizeModle}
          />
        </div>
        <div className='time-down' key={512}><span className='text'>{lang.timeR}</span> <span className='days-num'>{day}</span> <span className='days-text'>{lang.days}</span><span className='mit'>{hour}:{minute}:{second}</span></div>
        <div className='proposal-gifts'>
          <img className='img-proposal-gifts-title' src={language == 'ar'?'/img/activity/valentineDay/proposal-gifts-title_ar.png':language == 'tr'?'/img/activity/valentineDay/proposal-gifts-title_tr.png':'/img/activity/valentineDay/proposal-gifts-title.png'}></img>
          <img className='img-bg-proposal-gifts' src='/img/activity/valentineDay/proposal-gifts_bg.png' ></img>
          <div className='proposal-gifts-body'>
            <div className='in-text-conter'>{lang.tipText}</div>
            <div className='show-gift-root-ranking'>
              {giftList.length>0 && giftList.map((item,index)=>(<div className='show-gift-root-ranking-item' key={index}>
                <div className='item-in-prize'>
                  <div className='img-root'>
                    <img className='img-root-img' src={item.image}></img>
                    <div className='gift-time-root' ><img className='ruby-icon'  src='/img/activity/valentineDay/icon_ruby_tensix.png'></img><span>{item.gold}</span></div>
                  </div>
                  <div className='name-text'>{item.name}</div>
                </div>
              </div>))}
            </div>
          </div>
        </div>
        <div className='strand-stoves'>
          <img className='img-strand-stoves-title' src={language == 'ar'?'/img/activity/valentineDay/strand-stoves_title_ar.png':language == 'tr'?'/img/activity/valentineDay/strand-stoves_title_tr.png':'/img/activity/valentineDay/strand-stoves_title.png'}></img>
          <img className='img-bg-strand-stoves' src='/img/activity/valentineDay/strand-stoves_bg.png' ></img>
          <div className='strand-stoves-body'>
            {topRankList.length>0 && topRankList.map((item, index) => (<div className='top-one-root' key={index}>
              <div className='left-top'>
                <img className={language == 'ar'?'wing-root-ar':'wing-root'} src='/img/activity/valentineDay/img_wings_left.png'></img>
                <div className={language == 'ar'?'user-info-ar':'user-info'}>
                  <img className='user-info-img' src={item.cp1Avatar} onClick={()=>jumpToUser(item.cp1)}></img>
                  <div className='user-info-name'>{item.cp1Nickname}</div>
                  <div className='user-info-id'>ID: {item.cp1Duid}</div>
                </div>
              </div>
              <div className='middle-top'>
                <div className={`middle-top-title ${index == 0 ? 'top-zero-text-color' : index == 1 ? 'top-one-text-color' : 'top-two-text-color'}`}>{`TOP${index + 1}`}</div>
                <div className='middle-top-body'>
                  <img className='middle-top-body-img' src='/img/activity/valentineDay/icon_heartx_ranking.png'></img>
                  <div className='ranking-num'>{item.score>1000?(item.score/1000).toFixed(1)+'K':item.score}</div>
                </div>
              </div>
              <div className='right-top'>
                <div  className={language == 'ar'?'right-top-user-info-ar':'right-top-user-info'}>
                  <img className='user-info-img' src={item.cp2Avatar} onClick={()=>jumpToUser(item.cp2)}></img>
                  <div className='user-info-name'>{item.cp2Nickname}</div>
                  <div className='user-info-id'>ID: {item.cp2Duid}</div>
                </div>
                <img className={language == 'ar'?'right-top-wing-root-ar':'right-top-wing-root'} src='/img/activity/valentineDay/img_wings_right.png'></img>
              </div>
            </div>))}

          </div>
        </div>
        <img className='ranking-card' src={language == 'ar'?'/img/activity/valentineDay/ranking-card_bg_ar.png':language == 'tr'?'/img/activity/valentineDay/ranking-card_bg_tr.png':'/img/activity/valentineDay/ranking-card_bg.png'}></img>
        <div className='ranking-lovers-root'>
          <div className='scroll-root'>
          {rankList.length>0 && rankList.map((item,index)=>(<div className='ranking-lovers-root-item' key={index}>
            {index == 0 && <img className='rank-item-top-one' src='/img/activity/valentineDay/top_one_ranking_bg.png'></img>}
            {index == 1 && <img className='rank-item-top-one' src='/img/activity/valentineDay/top_two_ranking_bg.png'></img>}
            {index == 2 && <img className='rank-item-top-one' src='/img/activity/valentineDay/top_three_ranking_bg.png'></img>}
            <div className='ranking-lovers-root-item-body'>
              {index==0 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_one.png'></img>}
              {index==1 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_two.png'></img>}
              {index==2 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_three.png'></img>}
              {index>2 && <div className='high-text-root'>{index+1}</div>}
               <div className='user-info-intwotwo'>
                 <div className='user-info-intwotwo-left'>
                  <img className='left-img' src={item.cp1Avatar} onClick={()=>jumpToUser(item.cp1)}></img>
                  <div className='left-name'>{item.cp1Nickname}</div>
                 </div>
                 <div className='user-info-intwotwo-middle'>
                   <img className='middle-love' src='/img/activity/valentineDay/icon_middle-love.png'></img>
                   <div className='middle-love-num'> {item.score>1000?(item.score/1000).toFixed(1)+'K':item.score}</div>
                 </div>
                 <div className='user-info-intwotwo-left'>
                  <img className='left-img' src={item.cp2Avatar} onClick={()=>jumpToUser(item.cp2)}></img>
                  <div className='left-name'>{item.cp2Nickname}</div>
                 </div>
               </div>
            </div>
          </div>))}
          </div>
          
           <div className='my-ranking-btn'>
              {myRank.cpId>0 && myRank.rankIndex==1 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_one.png'></img>}
              {myRank.cpId>0 && myRank.rankIndex==2 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_two.png'></img>}
              {myRank.cpId>0 && myRank.rankIndex==3 && <img className='high-img' src='/img/activity/valentineDay/icon_crown_three.png'></img>}
              {myRank.cpId>0 && myRank.rankIndex > 3 && <div className='high-text-root'>{myRank.rankIndex}</div>}
              {myRank.cpId>0 && <div className='user-info-intwotwo'>
                 <div className='user-info-intwotwo-left'>
                  <img className='left-img' src={myRank.cp1Avatar ||''} onClick={()=>jumpToUser(myRank.cp1)}></img>
                  <div className='left-name'>{myRank.cp1Nickname ||''}</div>
                 </div>
                 <div className='user-info-intwotwo-middle'>
                   <img className='middle-love' src='/img/activity/valentineDay/icon_middle-love.png'></img>
                   <div className='middle-love-num'> {myRank && myRank.score>1000?(myRank.score/1000).toFixed(1)+'K':myRank.score}</div>
                 </div>
                 <div className='user-info-intwotwo-left'>
                  <img className='left-img' src={myRank.cp2Avatar ||''} onClick={()=>jumpToUser(myRank.cp2)}></img>
                  <div className='left-name'>{myRank.cp2Nickname ||''}</div>
                 </div>
               </div>}
            </div>
         
        </div>
        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/valentineDay/topLovers/index.js